import { BaseModal, BaseModalContent, BaseModalFooter, Button, ButtonVariants } from '@/tools/ui'

interface TranslationIssueFormModalProps {
  isOpen: boolean
  onClose: () => void
}

export const TranslationIssueFormModal = ({
  isOpen,
  onClose: handleOnClose,
}: TranslationIssueFormModalProps) => (
  <BaseModal isOpen={isOpen} onClose={handleOnClose}>
    <BaseModalContent>
      <h1>Translation Issue Form.</h1>
      <h2> https://glovoapp.atlassian.net/browse/WEB-121</h2>
    </BaseModalContent>
    <BaseModalFooter>
      <Button block label="Report" variant={ButtonVariants.primary} onClick={handleOnClose} />
    </BaseModalFooter>
  </BaseModal>
)
